const COLLAPSED_KEY = 'cp.nav.collapsed';

/**
 * Sidebar collapsed state.
 *
 * localStorage, like the theme preference and for the same reason: it is a
 * display choice rather than a credential, and it should survive closing the
 * browser. Every access is guarded because Safari private mode throws on
 * setItem and storage can be disabled by policy.
 */
export const navStorage = {
  getCollapsed(): boolean | null {
    try {
      const stored = window.localStorage.getItem(COLLAPSED_KEY);
      return stored === null ? null : stored === 'true';
    } catch {
      return null;
    }
  },

  setCollapsed(collapsed: boolean): void {
    try {
      window.localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch {
      // Preference simply won't persist.
    }
  },
};
